import React from 'react';
import { POSE_MAP, VEST_COLORS } from './poses';

interface PixelCharacterProps {
  pose: string;
  colorIndex?: number;
  size?: number;
  className?: string;
}

const animations: Record<string, string> = {
  sleeping: 'animate-snore',
  guitar: 'animate-rock',
  coffee: 'animate-sip',
  hammer: 'animate-swing',
  dancing: 'animate-dance',
  default: 'animate-idle',
};

export const PixelCharacter: React.FC<PixelCharacterProps> = ({
  pose,
  colorIndex = 0,
  size = 128,
  className = '',
}) => {
  const PoseComponent = POSE_MAP[pose] || POSE_MAP['hammer'];
  const vestColor = VEST_COLORS[colorIndex % VEST_COLORS.length];
  const animClass = animations[pose] || animations['default'];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      className={`pixel-character ${animClass} ${className}`}
      style={{ imageRendering: 'pixelated' }}
    >
      <PoseComponent color={vestColor} />
    </svg>
  );
};
